export default {
  title: 'Migrationsstatus: {type}',
  resetMessage: 'Sind Sie sicher, dass Sie den Migrationsstatus für {count} {type} zurücksetzen wollen?\n'
    + 'Infolgedessen werden alle {type} ab den ersten verfügbaren Daten vom PT9800 migriert.',
};
